import React, { useEffect } from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import TextSection from "components/views/atoms/TextSection";
import ReactMarkdown from "react-markdown";
import ProgressHeading from "components/views/ProgressHeading";
import ManufacturersList from "components/containers/ManufacturersList";
import OutlinedMoreHelp from "components/views/OutlinedMoreHelp";
import OutlinedLinksGrid from "components/views/OutlinedLinksGrid";
import EndOfPageNotes from "components/views/EndOfPageNotes";
import OutlinedMSLA from "components/views/OutlinedMSLA";
import OutlinedVisitHub from "components/views/OutlinedVisitHub";
import OutlinedMoreTechInfo from "components/views/OutlinedMoreTechInfo";
import ProductsTable from "components/containers/ProductsTable";
import Footer from "components/views/atoms/Footer";

const Home = ({ className }) => {

  useEffect(() => {
    const target = document.querySelectorAll("a[href='/comparisonList']")[0];
    
    if (target) {
      // eslint-disable-next-line
      target.onclick = function(e) {
        e.preventDefault();
        const newTarget = document.getElementById('comparisonList');
        newTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  const classes = ["Home"];
  const visitHubCopy = T({ path: "button.visitHub" });

  if (className) classes.push(className);

  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="common.productSelector" />
      </PageHeading>

      <Row fullWidth>
        <ProgressHeading
          perc={20}
          heading={T({ path: "homePage.progressHeading" })}
        />
      </Row>

      <Row>
        <TextSection>
          <ReactMarkdown>
            {T({ path: "homePage.intro", anchor: "/comparisonList" })}
          </ReactMarkdown>
        </TextSection>
      </Row>

      <Row>
        <ManufacturersList />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedMoreHelp LinkLabel={T({ path: "button.moreHelpUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row bgColor="azure">
        <TextSection>
          <h2 id="comparisonList">
            {T({ path: "homePage.productComparisonListTitle" })}
          </h2>
          <ReactMarkdown allowDangerousHtml>
            {T({ path: "homePage.productComparisonListBody" })}
          </ReactMarkdown>
        </TextSection>
        <ProductsTable />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedVisitHub doRender={visitHubCopy} LinkLabel={T({ path: "button.visitHubUrl" })} />
          <OutlinedMSLA LinkLabel={T({ path: "button.MSLAUrl" })} />
          <OutlinedMoreTechInfo LinkLabel={T({ path: "button.moreTechInfoUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row>
        <EndOfPageNotes />
      </Row>

      <Footer />
    </OneCol>
  );
};

Home.displayName = "Home";

Home.propTypes = {
  className: PropTypes.string,
};

Home.defaultProps = {
  className: null,
};

export default Home;
